import type { IconName } from '@/components/ui/Icon';
import { routes } from '@/lib/routes';

/** Каталог модулей кабинета владельца (10 модулей). */
export type Owner10ModuleDef = {
  key: string;
  num: string;
  title: string;
  text: string;
  accent: string;
  icon: IconName;
  to: string;
};

export const OWNER10_MODULES: Owner10ModuleDef[] = [
  {
    key: 'requests',
    num: '01',
    title: 'Заявки в работе',
    text: 'Очередь, статусы, исполнитель, срок, уточнения, история и предварительные ответы внутри заявки.',
    accent: '#41d2ff',
    icon: 'briefcase',
    to: `${routes.owner}/requests`,
  },
  {
    key: 'communications',
    num: '02',
    title: 'Коммуникации',
    text: 'Академические связи и почта владельца в одном центре коммуникаций.',
    accent: '#49ddb7',
    icon: 'chat',
    to: `${routes.owner}/communications`,
  },
  {
    key: 'decisions',
    num: '03',
    title: 'Решения и аудит',
    text: 'Решения владельца и история системы: версии, замены и журнал событий.',
    accent: '#e2ad3a',
    icon: 'shield',
    to: `${routes.owner}/decisions`,
  },
  {
    key: 'access',
    num: '04',
    title: 'Пользователи и доступы',
    text: 'Пользователи, категории, роли, приглашения, заявки на доступ и права.',
    accent: '#9e80ff',
    icon: 'user',
    to: `${routes.owner}/access`,
  },
  {
    key: 'coverage',
    num: '05',
    title: 'Coverage 11×72',
    text: '11 направлений × 72 услуги: полнота, вопросы, предварительные ответы и обязательные слои.',
    accent: '#66b7e8',
    icon: 'chart',
    to: `${routes.owner}/coverage`,
  },
  {
    key: 'tools',
    num: '06',
    title: 'Программы и инструменты',
    text: 'Опросы, эксперименты, анализ данных, визуализация и исследовательские инструменты.',
    accent: '#9e80ff',
    icon: 'chart',
    to: `${routes.owner}/tools`,
  },
  {
    key: 'announcements',
    num: '07',
    title: 'Объявления и обновления',
    text: 'Объявления, системные обновления, аудитории и публикация.',
    accent: '#41d2ff',
    icon: 'news',
    to: `${routes.owner}/announcements`,
  },
  {
    key: 'meetings',
    num: '08',
    title: 'Встречи и дежурства',
    text: 'Встречи, расписание, дежурства, приглашения, статусы и календарная синхронизация.',
    accent: '#49ddb7',
    icon: 'calendar',
    to: `${routes.owner}/meetings`,
  },
  {
    key: 'files',
    num: '09',
    title: 'Файлы и документы',
    text: 'Единое хранилище: исходные, рабочие, результаты, шаблоны, архив, версии и просмотр.',
    accent: '#41d2ff',
    icon: 'document',
    to: `${routes.owner}/files`,
  },
  {
    key: 'orders',
    num: '10',
    title: 'Заказы и публикации',
    text: 'Авторские обращения + Заказы клиентов + Совместные статьи в одном реестре.',
    accent: '#e2ad3a',
    icon: 'document',
    to: `${routes.owner}/orders`,
  },
];

export const OWNER10_BY_KEY = Object.fromEntries(
  OWNER10_MODULES.map((item) => [item.key, item]),
) as Record<string, Owner10ModuleDef>;

export function owner10RouteForKey(key: string): string {
  if (key === 'announcements') return `${routes.owner}/announcements`;
  if (key === 'content') return `${routes.owner}/content`;
  if (key === 'research-tools') return `${routes.owner}/tools`;
  const base = key.split('?')[0];
  const query = key.includes('?') ? `?${key.split('?')[1]}` : '';
  return (OWNER10_BY_KEY[base]?.to ?? `${routes.owner}/${base}`) + query;
}
